import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Register third-party stimulus controller here. `index.js` is auto-generated
// and replaced whenever new stimulus controller is generated.

import { Autocomplete } from "stimulus-autocomplete"
application.register('autocomplete', Autocomplete)

export { application }
